/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTestDto
 */
export interface GetTestDto {
    /**
     * 
     * @type {string}
     * @memberof GetTestDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetTestDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTestDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTestDto
     */
    identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTestDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTestDto
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetTestDto
     */
    lp?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTestDto
     */
    onlineOption: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTestDto
     */
    needDevice: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTestDto
     */
    withoutHarmfulFactors: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTestDto
     */
    generateSupportingExamination: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetTestDto
     */
    creationTs?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof GetTestDto
     */
    averageDuration?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTestDto
     */
    hasManual?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof GetTestDto
     */
    completed_exams_count?: number | null;
}

/**
 * Check if a given object implements the GetTestDto interface.
 */
export function instanceOfGetTestDto(value: object): value is GetTestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('onlineOption' in value) || value['onlineOption'] === undefined) return false;
    if (!('needDevice' in value) || value['needDevice'] === undefined) return false;
    if (!('withoutHarmfulFactors' in value) || value['withoutHarmfulFactors'] === undefined) return false;
    if (!('generateSupportingExamination' in value) || value['generateSupportingExamination'] === undefined) return false;
    return true;
}

export function GetTestDtoFromJSON(json: any): GetTestDto {
    return GetTestDtoFromJSONTyped(json, false);
}

export function GetTestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'description': json['description'] == null ? undefined : json['description'],
        'active': json['active'],
        'lp': json['lp'] == null ? undefined : json['lp'],
        'onlineOption': json['onlineOption'],
        'needDevice': json['needDevice'],
        'withoutHarmfulFactors': json['withoutHarmfulFactors'],
        'generateSupportingExamination': json['generateSupportingExamination'],
        'creationTs': json['creationTs'] == null ? undefined : (new Date(json['creationTs'])),
        'averageDuration': json['averageDuration'] == null ? undefined : json['averageDuration'],
        'hasManual': json['hasManual'] == null ? undefined : json['hasManual'],
        'completed_exams_count': json['completed_exams_count'] == null ? undefined : json['completed_exams_count'],
    };
}

export function GetTestDtoToJSON(value?: GetTestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'fileName': value['fileName'],
        'identifier': value['identifier'],
        'description': value['description'],
        'active': value['active'],
        'lp': value['lp'],
        'onlineOption': value['onlineOption'],
        'needDevice': value['needDevice'],
        'withoutHarmfulFactors': value['withoutHarmfulFactors'],
        'generateSupportingExamination': value['generateSupportingExamination'],
        'creationTs': value['creationTs'] == null ? undefined : ((value['creationTs'] as any).toISOString()),
        'averageDuration': value['averageDuration'],
        'hasManual': value['hasManual'],
        'completed_exams_count': value['completed_exams_count'],
    };
}

